import { render } from "./onBoardingTable.vue?vue&type=template&id=c266df7a&scoped=true&ts=true"
import script from "./onBoardingTable.vue?vue&type=script&lang=ts"
export * from "./onBoardingTable.vue?vue&type=script&lang=ts"

import "./onBoardingTable.vue?vue&type=style&index=0&id=c266df7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c266df7a"]])

export default __exports__